/**
 * @generated SignedSource<<7974b7ff2726f6f406d502427b1fdbce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingAddressListWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddShippingAddress_viewer" | "CheckoutShippingAddressList_viewer">;
  readonly " $fragmentType": "CheckoutShippingAddressListWrapper_viewer";
};
export type CheckoutShippingAddressListWrapper_viewer$key = {
  readonly " $data"?: CheckoutShippingAddressListWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingAddressListWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingAddressListWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingAddressList_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAddShippingAddress_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b5b3a1dcccedb67633b0519b4f81751d";

export default node;
